__turbopack_context__.v({
  "navigation": "MainNavigation-module-scss-module__J4O-dq__navigation",
  "navigationTabs": "MainNavigation-module-scss-module__J4O-dq__navigationTabs",
  "open": "MainNavigation-module-scss-module__J4O-dq__open",
  "themeSelectorCaption": "MainNavigation-module-scss-module__J4O-dq__themeSelectorCaption",
});
